import { SVGProps, Ref, forwardRef } from 'react';

export const FolderHyperstarFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M18.436 10.3c1.928 0 3.296.196 4.193.675 1.458.777 1.67 2.301 1.019 4.943-.63-.59-1.21-1.257-1.65-1.916L20.5 11.755l-1.497 2.247a11.5 11.5 0 0 1-3 3L13.755 18.5l2.248 1.498a11.4 11.4 0 0 1 2.092 1.843c-.696.106-1.48.159-2.365.159H8.27c-5.093 0-6.814-1.668-7.9-6-.676-2.692-.473-4.24 1-5.025.897-.48 2.266-.675 4.194-.675z"
                        fill="currentColor"
                    />
                    <path
                        d="M20.5 15a13.3 13.3 0 0 0 3.5 3.5 13.3 13.3 0 0 0-3.5 3.5 13.3 13.3 0 0 0-3.5-3.5 13.3 13.3 0 0 0 3.5-3.5"
                        fill="currentColor"
                    />
                    <path
                        d="M12.3 4h3.33c4.51 0 6.438 1.292 6.891 4.986-1.31-.423-2.72-.486-4.085-.486H5.564c-1.402 0-2.856.065-4.194.522V9c0-5.25 1.75-7 7-7h3.13z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
FolderHyperstarFilledSize24Glyph.displayName = 'FolderHyperstarFilledSize24Glyph';
